import React, { useCallback } from 'react'
import { FieldHookConfig, useField } from 'formik'
import { ToggleButtonGroup as UIToggleButtonGroup } from '@carsys/ui'
import { isInvalid } from './utils'
import { useFormSection } from './FormSection'
import { useRegisterFormField } from './TabbedForm/FormTabPanel'

interface ToggleButtonGroupProps
  extends Omit<React.ComponentProps<typeof UIToggleButtonGroup>, 'name'>,
    Pick<FieldHookConfig<any>, 'name' | 'validate'> {}

export function ToggleButtonGroup({ children, name, validate, onBlur, ...props }: ToggleButtonGroupProps) {
  const [input, meta, helpers] = useField({ name, validate })
  useRegisterFormField(name)
  const formSection = useFormSection()

  const blurHandler = useCallback(
    e => {
      helpers.setTouched(true)
      onBlur?.(e)
    },
    [onBlur]
  )

  const changeHandler = useCallback((_, v) => helpers.setValue(v), [helpers.setValue])

  return (
    <UIToggleButtonGroup
      error={isInvalid(meta)}
      disabled={formSection.disabled}
      {...props}
      {...input}
      helperText={isInvalid(meta) ? meta.error : props.helperText}
      onBlur={blurHandler}
      onChange={changeHandler}
    >
      {children}
    </UIToggleButtonGroup>
  )
}
